import React from 'react'
import intl from 'react-intl-universal';
import { 
    Checkbox,
    Row,
    Col,
    Select,
    Input,
 } from 'antd';
 const { Option } = Select;
 import {getElementByIconClass} from '../../../../../src/utils/utils.js'
 import { store } from 'Store/store.index';

const localStoreKey = "PREFERENCES-DOCUMENTS";
let defaultSettings = {
    fullScreenAlert: true,
    vieMode: 'onlyForPDFA',
    saveFrequency: true,
    saveFrequencyValue: 5,
    saveForFastWeb: false,
    redaction: true,
    redactionPrefix: '',
    redactionSuffix: '_Redacted',
}
const localSettings = window.localStorage[localStoreKey];
if(!window.localStorage[localStoreKey]) {
    window.localStorage.setItem(localStoreKey, JSON.stringify(defaultSettings));
} else {
    defaultSettings = JSON.parse(localSettings);
}
if (!defaultSettings.hasOwnProperty('autoUploadToFoxitStorage')) {
    defaultSettings.autoUploadToFoxitStorage = true;
    window.localStorage.setItem(localStoreKey, JSON.stringify(defaultSettings));
}
export default class Document extends React.Component {
    state = {
        form: defaultSettings,
    }
    componentDidMount() {
        const localSettings = window.localStorage.getItem(localStoreKey);
        if(localSettings) {
            this.setState({
                form: JSON.parse(localSettings)
            })
        }
    }
    formValueChange = (key, value) => {
        this.setFormData(key, value);
    }
    setFormData(key, val) {
        // if(typeof str === 'string') val.trim();
        this.setState({
            form: {
                ...this.state.form,
                [key]: val,
            }
        })
    }
    saveSettingsToLocalStorage() {
        const form = this.state.form;
        window.localStorage.setItem(localStoreKey, JSON.stringify(form));
        const isProtectedView = localStorage.getItem('SECURITY_PROTECTED_VIEW') === 'all' ? true:false;
        const optimizerDom = document.querySelector('div[icon-class="fv__icon-toolbar-pdf-optimizer"]');
        const articleDom = document.querySelector('div[icon-class="fv__icon-toolbar-add-article"]');
        const measurementDom = getElementByIconClass('fv__icon-toolbar-measurement');
        const stampDom = getElementByIconClass('fv__icon-toolbar-stamp');
        const importDom = getElementByIconClass('fv__icon-toolbar-import');
        const rotatepageDom = getElementByIconClass('fx-icon-ribbon_home_rotatepagesleft-32');
        const watermarkDom = getElementByIconClass('fv__icon-toolbar-watermark');
        const flattenDom = getElementByIconClass('fv__icon-toolbar-flatten-pdf');
        const headerfooterDom = getElementByIconClass('fv__icon-toolbar-headerfooter');
        const insertPagesDom = getElementByIconClass('fv__icon-toolbar-insert-pages');
        const reversePagesDom = getElementByIconClass('fv__icon-toolbar-reverse-pages');
        const backgroundDom = getElementByIconClass('fv__icon-toolbar-background');
        const recognitionDom = document.querySelector('div[icon-class="fv__icon-toolbar-recognition-form"]');
        const createPushbuttonDom = document.querySelector('div[icon-class="fv__icon-toolbar-form-create-push-button"]');
        const addToolTipDom = document.querySelector('div[icon-class="fv__icon-toolbar-add-tooltip"]');
        const createCheckBoxDom = document.querySelector('div[icon-class="fv__icon-toolbar-form-create-check-box"]');
        const createRadionDom = document.querySelector('div[icon-class="fv__icon-toolbar-form-create-radio-button"]');
        const createTextDom = document.querySelector('div[icon-class="fv__icon-toolbar-form-create-text"]');
        const createSignDom = document.querySelector('div[icon-class="fv__icon-toolbar-form-create-sign"]');
        function addDiableAttr (elementArr) {
            elementArr.forEach(element => {
                !isProtectedView && element.classList.add('fx-ribbon-item-disabled');
            })
          }
          function removeDisableAttr (elementArr) {
            elementArr.forEach(element => {
                !isProtectedView && element.classList.remove('fx-ribbon-item-disabled');;
            })
          }
          let mayChangaeEle = [measurementDom,stampDom,importDom,insertPagesDom,reversePagesDom,backgroundDom,
                rotatepageDom,watermarkDom,flattenDom,headerfooterDom];

        const { vieMode } = form;
        if (vieMode === 'never') {
            !isProtectedView && optimizerDom.classList.remove('fx-ribbon-item-disabled');
            !isProtectedView && articleDom.classList.remove('fx-ribbon-item-disabled');
            !isProtectedView && recognitionDom.classList.remove('fx-ribbon-item-disabled');
            !isProtectedView && createPushbuttonDom.classList.remove('fx-ribbon-item-disabled');
            !isProtectedView && addToolTipDom.classList.remove('fx-ribbon-item-disabled');
            !isProtectedView && createRadionDom.classList.remove('fx-ribbon-item-disabled');
            !isProtectedView && createTextDom.classList.remove('fx-ribbon-item-disabled');
            !isProtectedView && createSignDom.classList.remove('fx-ribbon-item-disabled');
            !isProtectedView && createCheckBoxDom.classList.remove('fx-ribbon-item-disabled');
            addDiableAttr(mayChangaeEle)
        } else if (vieMode === 'onlyForPDFA') {
            !isProtectedView && optimizerDom.classList.add('fx-ribbon-item-disabled');
            !isProtectedView && articleDom.classList.add('fx-ribbon-item-disabled');
            !isProtectedView && recognitionDom.classList.add('fx-ribbon-item-disabled');
            !isProtectedView && createPushbuttonDom.classList.add('fx-ribbon-item-disabled');
            !isProtectedView && addToolTipDom.classList.add('fx-ribbon-item-disabled');
            !isProtectedView && createRadionDom.classList.add('fx-ribbon-item-disabled');
            !isProtectedView && createTextDom.classList.add('fx-ribbon-item-disabled');
            !isProtectedView && createSignDom.classList.add('fx-ribbon-item-disabled');
            !isProtectedView && createCheckBoxDom.classList.add('fx-ribbon-item-disabled');
            removeDisableAttr(mayChangaeEle);
        }
    }
    render() {
        const { 
            form: { 
                fullScreenAlert, 
                autoUploadToFoxitStorage,
                vieMode, 
                saveForFastWeb,
                redaction,
                redactionPrefix,
                redactionSuffix,
            }
        } = this.state;
        return (
            <div className="preferences-document">
                <div className="title">{intl.formatMessage({ id: 'Preferences.Content.DocumentTab.openSettings.title' })}</div>
                <div className="board">
                    <Checkbox 
                        onChange={(e) => this.formValueChange('fullScreenAlert', e.target.checked)}
                        checked={fullScreenAlert}
                    >
                        { intl.formatMessage({ id: 'Preferences.Content.DocumentTab.openSettings.fullScreenAlert' }) }
                    </Checkbox>
                </div>
                {
                    store.appStore.isIncludeFoxitStorage && <div className="board">
                        <Checkbox disabled={store.storageAppStore.isDisableStorage}
                            onChange={(e) => this.formValueChange('autoUploadToFoxitStorage', e.target.checked)}
                            checked={autoUploadToFoxitStorage}
                        >
                            { intl.formatMessage({ id: 'Preferences.Content.DocumentTab.openSettings.autoUploadToFoxitStorage' }) }
                        </Checkbox>
                    </div>
                }
                <div className="title">{intl.formatMessage({ id: 'Preferences.Content.DocumentTab.viewMode.title' })}:</div>
                <div className="board">
                   <Row>
                       <Col span={12} style={{ fontSize: '14px' }}>{intl.formatMessage({ id: 'Preferences.Content.DocumentTab.viewMode.desc' })}</Col>
                       <Col span={12}>
                            <Select 
                                style={{ width: 220 }}
                                value={vieMode}
                                onChange={val => this.formValueChange('vieMode', val)}
                                size="small"
                            >
                                <Option value="never">{intl.formatMessage({ id: 'Preferences.Content.DocumentTab.viewMode.never' })}</Option>
                                <Option value="onlyForPDFA">{intl.formatMessage({ id: 'Preferences.Content.DocumentTab.viewMode.onlyForPDFA' })}</Option>
                            </Select>
                       </Col>
                   </Row>
                </div>
                <div className="title">{intl.formatMessage({ id: 'Preferences.Content.DocumentTab.saveSettings.title' })}</div>
                <div className="board">
                   <Row>
                       {/* <Col span={14}>
                       <Checkbox 
                            onChange={(e) => this.formValueChange('saveFrequency', e.target.checked)}
                            checked={saveFrequency}
                        >
                            { intl.formatMessage({ id: 'Preferences.Content.DocumentTab.saveSettings.saveFrequency' }) }
                        </Checkbox>
                       </Col>
                       <Col span={7}>
                            <InputNumber 
                                min={1}
                                max={99} 
                                size="small"
                                style={{width: "90%"}}
                                value={saveFrequencyValue}
                                onChange={val => this.formValueChange('saveFrequencyValue', val)} 
                                disabled={!saveFrequency} />
                       </Col>
                       <Col span={3} style={{fontSize: "14px"}}>
                            { intl.formatMessage({ id: 'Preferences.Content.DocumentTab.saveSettings.minutes' }) }
                       </Col> */}
                       <Col span={24}>
                        <Checkbox 
                                onChange={(e) => this.formValueChange('saveForFastWeb', e.target.checked)}
                                checked={saveForFastWeb}
                            >
                                { intl.formatMessage({ id: 'Preferences.Content.DocumentTab.saveSettings.saveForFastWeb' }) }
                            </Checkbox>
                       </Col>
                   </Row>
                </div>
                <div className="title">{intl.formatMessage({ id: 'Preferences.Content.DocumentTab.redaction.title' })}</div>
                <div className="board">
                    <Row>
                        <Col span={24}>
                            <Checkbox 
                                onChange={(e) => this.formValueChange('redaction', e.target.checked)}
                                checked={redaction}
                            >
                                { intl.formatMessage({ id: 'Preferences.Content.DocumentTab.redaction.setredaction' }) }
                            </Checkbox>
                        </Col>
                    </Row>
                    <Row style={{ marginTop:"10px" }} gutter={24}>
                        <Col span={10}>
                            <Input
                                addonBefore={intl.formatMessage({ id: 'Preferences.Content.DocumentTab.redaction.prefix' }) + ":"}
                                size="small"
                                value={redactionPrefix}
                                disabled={!redaction}
                                onChange={(e) => this.formValueChange('redactionPrefix', e.target.value)}
                                placeholder={ intl.formatMessage({ id: 'Preferences.Content.DocumentTab.redaction.prefix' }) } 
                            />
                        </Col>
                        <Col span={10}>
                            <Input
                                value={redactionSuffix}
                                addonBefore={intl.formatMessage({ id: 'Preferences.Content.DocumentTab.redaction.suffix' }) + ":"}
                                size="small"
                                disabled={!redaction}
                                onChange={(e) => this.formValueChange('redactionSuffix', e.target.value)}
                                placeholder={ intl.formatMessage({ id: 'Preferences.Content.DocumentTab.redaction.suffix' }) } 
                            />
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }
}